import { RouteObject } from 'react-router-dom'
import { CsvUpload } from './csv-upload'

export const routes: RouteObject[] = [
  {
    path: 'baloise-upload',
    children: [{ index: true, element: <CsvUpload /> }],
  },
]
